import React from "react";
import {Route, Switch} from "react-router-dom";

import PatientInformationView from "./Seating/Patient/patientInformationView";
import UserList from "./Seating/Users/userList";
import UserEdit from "./Seating/Users/userEdit";
import UserAdd from "./Seating/Users/userAdd";

// Login/Authorize/Load
import Login from "./Layer/Login";
import Authorize from "./Layer/Authorize";
import Load from "./Layer/Load";
import Logout from "./Layer/Logout";

// Dictionary Admin Layers
import AdminAccountTypeCreateEdit from "./Layer/Admin/AccountType/AdminAccountTypeCreateEdit";
import AdminAccountTypeList from "./Layer/Admin/AccountType/AdminAccountTypeList";
import AdminBaseUnitCreateEdit from "./Layer/Admin/BaseUnit/AdminBaseUnitCreateEdit";
import AdminBaseUnitList from "./Layer/Admin/BaseUnit/AdminBaseUnitList";
import AdminBaseUnitTypeCreateEdit from "./Layer/Admin/BaseUnitType/AdminBaseUnitTypeCreateEdit";
import AdminBaseUnitTypeList from "./Layer/Admin/BaseUnitType/AdminBaseUnitTypeList";
import AdminBtProductCreateEdit from "./Layer/Admin/BtProduct/AdminBtProductCreateEdit";
import AdminBtProductList from "./Layer/Admin/BtProduct/AdminBtProductList";
import AdminContactTypeCreateEdit from "./Layer/Admin/ContactType/AdminContactTypeCreateEdit";
import AdminContactTypeList from "./Layer/Admin/ContactType/AdminContactTypeList";
import AdminDepartmentCreateEdit from "./Layer/Admin/Department/AdminDepartmentCreateEdit";
import AdminDepartmentList from "./Layer/Admin/Department/AdminDepartmentList";
import AdminDiagnosisCodeCreateEdit from "./Layer/Admin/DiagnosisCode/AdminDiagnosisCodeCreateEdit";
import AdminDiagnosisCodeList from "./Layer/Admin/DiagnosisCode/AdminDiagnosisCodeList";
import AdminDistributionReasonCreateEdit from "./Layer/Admin/DistributionReason/AdminDistributionCreateEdit";
import AdminDistributionReasonList from "./Layer/Admin/DistributionReason/AdminDistributionReasonList";
import AdminFeeScheduleCreateEdit from "./Layer/Admin/FeeSchedule/AdminFeeScheduleCreateEdit";
import AdminFeeScheduleList from "./Layer/Admin/FeeSchedule/AdminFeeScheduleList";
import AdminHcpcsCodeCreateEdit from "./Layer/Admin/HcpcsCode/AdminHcpcsCodeCreateEdit";
import AdminHcpcsCodeList from "./Layer/Admin/HcpcsCode/AdminHcpcsCodeList";
import AdminInsuranceSubTypeCreateEdit from "./Layer/Admin/InsuranceSubType/AdminInsuranceSubTypeCreateEdit";
import AdminInsuranceSubTypeList from "./Layer/Admin/InsuranceSubType/AdminInsuranceSubTypeList";
import AdminInsuranceTypeCreateEdit from "./Layer/Admin/InsuranceType/AdminInsuranceTypeCreateEdit";
import AdminInsuranceTypeList from "./Layer/Admin/InsuranceType/AdminInsuranceTypeList";
import AdminIssueCategoryCreateEdit from "./Layer/Admin/IssueCategory/AdminIssueCategoryCreateEdit";
import AdminIssueCategoryList from "./Layer/Admin/IssueCategory/AdminIssueCategoryList";
import AdminIssueReasonCreateEdit from "./Layer/Admin/IssueReason/AdminIssueReasonCreateEdit";
import AdminIssueReasonList from "./Layer/Admin/IssueReason/AdminIssueReasonList";
import AdminLocationCreateEdit from "./Layer/Admin/Location/AdminLocationCreateEdit";
import AdminLocationList from "./Layer/Admin/Location/AdminLocationList";
import AdminMarketingCampaignCategoryCreateEdit from "./Layer/Admin/MarketingCampaignCategory/AdminMarketingCampaignCategoryCreateEdit";
import AdminMarketingCampaignCategoryList from "./Layer/Admin/MarketingCampaignCategory/AdminMarketingCampaignCategoryList";
import AdminMarketingCampaignCreateEdit from "./Layer/Admin/MarketingCampaign/AdminMarketingCampaignCreateEdit";
import AdminMarketingCampaignList from "./Layer/Admin/MarketingCampaign/AdminMarketingCampaignList";
import AdminModifierCodeCreateEdit from "./Layer/Admin/ModifierCode/AdminModifierCodeCreateEdit";
import AdminModifierCodeList from "./Layer/Admin/ModifierCode/AdminModifierCodeList";
import AdminOrderActivityTypeCreateEdit from "./Layer/Admin/OrderActivityType/AdminOrderActivityTypeCreateEdit";
import AdminOrderActivityTypeList from "./Layer/Admin/OrderActivityType/AdminOrderActivityTypeList";
import AdminOrderStatusReasonCreateEdit from "./Layer/Admin/OrderStatusReason/AdminOrderStatusReasonCreateEdit";
import AdminOrderStatusReasonList from "./Layer/Admin/OrderStatusReason/AdminOrderStatusReasonList";
import AdminOrderStatusReasonDetailCreateEdit from "./Layer/Admin/OrderStatusReasonDetail/AdminOrderStatusReasonDetailCreateEdit";
import AdminOrderStatusReasonDetailList from "./Layer/Admin/OrderStatusReasonDetail/AdminOrderStatusReasonDetailList";
import AdminProviderCreateEdit from "./Layer/Admin/Provider/AdminProviderCreateEdit";
import AdminProviderList from "./Layer/Admin/Provider/AdminProviderList";
import AdminPermissionCreateEdit from "./Layer/Admin/Permission/AdminPermissionCreateEdit";
import AdminPermissionList from "./Layer/Admin/Permission/AdminPermissionList";
import AdminQueueCreateEdit from "./Layer/Admin/Queue/AdminQueueCreateEdit";
import AdminQueueList from "./Layer/Admin/Queue/AdminQueueList";
import AdminQueueRouteCreateEdit from "./Layer/Admin/QueueRoute/AdminQueueRouteCreateEdit";
import AdminQueueRouteList from "./Layer/Admin/QueueRoute/AdminQueueRouteList";
import AdminDashboardCreateEdit from "./Layer/Admin/Dashboard/AdminDashboardCreateEdit";
import AdminDashboardList from "./Layer/Admin/Dashboard/AdminDashboardList";
import AdminWidgetCreateEdit from "./Layer/Admin/Widget/AdminWidgetCreateEdit";
import AdminWidgetList from "./Layer/Admin/Widget/AdminWidgetList";
import AdminRegionCreateEdit from "./Layer/Admin/Region/AdminRegionCreateEdit";
import AdminRegionList from "./Layer/Admin/Region/AdminRegionList";
import AdminRoleCreateEdit from "./Layer/Admin/Role/AdminRoleCreateEdit";
import AdminRoleList from "./Layer/Admin/Role/AdminRoleList";
import AdminTeamCreateEdit from "./Layer/Admin/Team/AdminTeamCreateEdit";
import AdminTeamList from "./Layer/Admin/Team/AdminTeamList";
import AdminUserProductionTypeCreateEdit from "./Layer/Admin/UserProductionType/AdminUserProductionTypeCreateEdit";
import AdminUserProductionTypeList from "./Layer/Admin/UserProductionType/AdminUserProductionTypeList";

// Terms
import AdminTermCreateEditBrightreeInvoiceStatus from "./Layer/Admin/Term/TermCreateEdit/AdminTermCreateEditBrightreeInvoiceStatus";
import AdminTermListBrightreeInvoiceStatus from "./Layer/Admin/Term/TermList/AdminTermListBrightreeInvoiceStatus";

import AdminTermCreateEditCommissionTier from "./Layer/Admin/Term/TermCreateEdit/AdminTermCreateEditCommissionTier";
import AdminTermListCommissionTier from "./Layer/Admin/Term/TermList/AdminTermListCommissionTier";

import AdminTermCreateEditDistributionReasonType from "./Layer/Admin/Term/TermCreateEdit/AdminTermCreateEditDistributionReasonType";
import AdminTermListDistributionReasonType from "./Layer/Admin/Term/TermList/AdminTermListDistributionReasonType";

import AdminTermCreateEditDistributionType from "./Layer/Admin/Term/TermCreateEdit/AdminTermCreateEditDistributionType";
import AdminTermListDistributionType from "./Layer/Admin/Term/TermList/AdminTermListDistributionType";

import AdminTermCreateEditEvaluationType from "./Layer/Admin/Term/TermCreateEdit/AdminTermCreateEditEvaluationType";
import AdminTermListEvaluationType from "./Layer/Admin/Term/TermList/AdminTermListEvaluationType";

import AdminTermCreateEditInsuranceSubTypeGroup from "./Layer/Admin/Term/TermCreateEdit/AdminTermCreateEditInsuranceSubTypeGroup";
import AdminTermListInsuranceSubTypeGroup from "./Layer/Admin/Term/TermList/AdminTermListInsuranceSubTypeGroup";

import AdminTermCreateEditInvoiceFollowupStatus from "./Layer/Admin/Term/TermCreateEdit/AdminTermCreateEditInvoiceFollowupStatus";
import AdminTermListInvoiceFollowupStatus from "./Layer/Admin/Term/TermList/AdminTermListInvoiceFollowupStatus";

import AdminTermCreateEditMarketingPreferredContactMethod from "./Layer/Admin/Term/TermCreateEdit/AdminTermCreateEditMarketingPreferredContactMethod";
import AdminTermListMarketingPreferredContactMethod from "./Layer/Admin/Term/TermList/AdminTermListMarketingPreferredContactMethod";

import AdminTermCreateEditNoteType from "./Layer/Admin/Term/TermCreateEdit/AdminTermCreateEditNoteType";
import AdminTermListNoteType from "./Layer/Admin/Term/TermList/AdminTermListNoteType";

import AdminTermCreateEditTimeZone from "./Layer/Admin/Term/TermCreateEdit/AdminTermCreateEditTimeZone";
import AdminTermListTimeZone from "./Layer/Admin/Term/TermList/AdminTermListTimeZone";

import AdminTermCreateEditPlaceOfService from "./Layer/Admin/Term/TermCreateEdit/AdminTermCreateEditPlaceOfService";
import AdminTermListPlaceOfService from "./Layer/Admin/Term/TermList/AdminTermListPlaceOfService";

import AdminTermCreateEditQueueType from "./Layer/Admin/Term/TermCreateEdit/AdminTermCreateEditQueueType";
import AdminTermListQueueType from "./Layer/Admin/Term/TermList/AdminTermListQueueType";

import AdminTermCreateEditRegionType from "./Layer/Admin/Term/TermCreateEdit/AdminTermCreateEditRegionType";
import AdminTermListRegionType from "./Layer/Admin/Term/TermList/AdminTermListRegionType";

import AdminTermCreateEditServicePartCatalogCategory from "./Layer/Admin/Term/TermCreateEdit/AdminTermCreateEditServicePartCatalogCategory";
import AdminTermListServicePartCatalogCategory from "./Layer/Admin/Term/TermList/AdminTermListServicePartCatalogCategory";

import AdminTermCreateEditServiceQuotePartReason from "./Layer/Admin/Term/TermCreateEdit/AdminTermCreateEditServiceQuotePartReason";
import AdminTermListServiceQuotePartReason from "./Layer/Admin/Term/TermList/AdminTermListServiceQuotePartReason";

import AdminTermCreateEditServiceQuotePartSource from "./Layer/Admin/Term/TermCreateEdit/AdminTermCreateEditServiceQuotePartSource";
import AdminTermListServiceQuotePartSource from "./Layer/Admin/Term/TermList/AdminTermListServiceQuotePartSource";

import AdminTermCreateEditServiceQuotePartStatus from "./Layer/Admin/Term/TermCreateEdit/AdminTermCreateEditServiceQuotePartStatus";
import AdminTermListServiceQuotePartStatus from "./Layer/Admin/Term/TermList/AdminTermListServiceQuotePartStatus";

import AdminTermCreateEditUserProductionDetailType from "./Layer/Admin/Term/TermCreateEdit/AdminTermCreateEditUserProductionDetailType";
import AdminTermListUserProductionDetailType from "./Layer/Admin/Term/TermList/AdminTermListUserProductionDetailType";

import AdminTermCreateEditNotificationStatus from "./Layer/Admin/Term/TermCreateEdit/AdminTermCreateEditNotificationStatus";
import AdminTermListNotificationStatus from "./Layer/Admin/Term/TermList/AdminTermListNotificationStatus";

import AdminTermCreateEditNotificationType from "./Layer/Admin/Term/TermCreateEdit/AdminTermCreateEditNotificationType";
import AdminTermListNotificationType from "./Layer/Admin/Term/TermList/AdminTermListNotificationType";

import AdminTermCreateEditNotificationChannel from "./Layer/Admin/Term/TermCreateEdit/AdminTermCreateEditNotificationChannel";
import AdminTermListNotificationChannel from "./Layer/Admin/Term/TermList/AdminTermListNotificationChannel";

import AdminTermCreateEditBrightreeStopHoldType from "./Layer/Admin/Term/TermCreateEdit/AdminTermCreateEditBrightreeStopHoldType";
import AdminTermListBrightreeStopHoldType from "./Layer/Admin/Term/TermList/AdminTermListBrightreeStopHoldType";

import AdminTermCreateEditBrightreeStopHoldReason from "./Layer/Admin/Term/TermCreateEdit/AdminTermCreateEditBrightreeStopHoldReason";
import AdminTermListBrightreeStopHoldReason from "./Layer/Admin/Term/TermList/AdminTermListBrightreeStopHoldReason";

import AdminTermCreateEditGenderIdentity from "./Layer/Admin/Term/TermCreateEdit/AdminTermCreateEditGenderIdentity";
import AdminTermListGenderIdentity from "./Layer/Admin/Term/TermList/AdminTermListGenderIdentity";

import AdminTermCreateEditActivityFileType from "./Layer/Admin/Term/TermCreateEdit/AdminTermCreateEditActivityFileType";
import AdminTermListActivityFileType from "./Layer/Admin/Term/TermList/AdminTermListActivityFileType";
import AdminTerms from "./Layer/Admin/Term/AdminTerms";
import AdminTermCreateEditTerms from "./Layer/Admin/Term/AdminTermCreateEditTerms";
import AdminTermCreateEditBusinessSupportRequestResolution from "./Layer/Admin/Term/TermCreateEdit/AdminTermCreateEditBusinessSupportRequestResolution";
import AdminTermListBusinessSupportRequestResolution from "./Layer/Admin/Term/TermList/AdminTermListBusinessSupportRequestResolution";

import AdminTermCreateEditPreferredPronouns from "./Layer/Admin/Term/TermCreateEdit/AdminTermCreateEditPreferredPronouns";
import AdminTermListPreferredPronouns from "./Layer/Admin/Term/TermList/AdminTermListPreferredPronouns";

// Dictionary Sales Layers
import PcrLinks from "./Layer/Sales/PcrLinks";

// Queues
import Queue from "./Layer/Queue/Queue";
import QueueDashboard from "./Layer/Queue/QueueDashboard";

// Dashboard
import Dashboard from "./Layer/Dashboard/Dashboard";

// Inbound Files
import InboundFiles from "./Layer/InboundFIles/InboundFiles";

// Chart
import PatientCreate from "./Layer/PatientCreate";
import Chart from "./Layer/Chart";

// Other
import FileViewer from "./Component/FileViewer";
import PatientSearch from "./Layer/PatientSearch";
import PatientCollections from "./Layer/Operations/PatientCollections/PatientCollections";
import ReportMetric from "./Layer/Report/ReportMetric";
import ARDashboard from "./Layer/Report/ARDashboard";
import OrderTimelineAudit from "./Layer/Report/OrderTimelineAudit";
import SalesScorecard from "./Layer/Report/SalesScorecard";
import InServiceSummary from "./Layer/Report/InServiceSummary";
import MyAccounts from "./Layer/Report/MyAccounts";
import UserProductionDetailBrightreeInvoice from "./Layer/Report/UserProductionDetail/UserProductionDetailBrightreeInvoice";

// Old Stuff
import ThirdPartyUserList from "./Seating/Users/thirdPartyUserList";
import OrderList from "./Seating/Orders/orderList";
import ContactEdit from "./Seating/Contacts/contact-edit";
import RecurringOrders from "./Seating/Orders/RecurringOrders";
import DeliveryManifest from "./Seating/Patient/deliveryManifest";
import PurchaseQueueView from "./Seating/PurchaseQueue/purchaseQueueView";
import InventoryRequest from "./Seating/PurchaseQueue/inventoryRequest";
import StateSalesTax from "./Seating/Settings/stateSalesTax";
import DailyOrderCounts from "./Seating/Reports/dailyOrderCounts";
import InventoryTacking from "./Seating/Deliveries/inventoryTracking";
import CollectionsView from "./Seating/Orders/collectionsView";
import AccountList from "./Seating/Accounts/accountList";
import AccountDetail from "./Seating/Accounts/accountDetail";
import AccountCreateEdit from "./Layer/Admin/Accounts/AccountCreateEdit";
import ActivityList from "./Seating/Activities/activities-list";
import ActivityEdit from "./Seating/Activities/activities-edit";
import ProductTypes from "./Seating/Settings/productTypes";
import EditProductSubType from "./Seating/Settings/editProductSubTypes";
import AddProductSubType from "./Seating/Settings/addProductSubType";
import CreditCardTypes from "./Seating/Settings/creditCardTypes";
import ExpenseTypes from "./Seating/Settings/expenseTypes";
import DeliveryAcknowledgements from "./Seating/Settings/deliveryAcknowledgements";
import AddDeliveryAcknowledgement from "./Seating/Settings/addDeliveryAcknowledgement";
import Reasons from "./Seating/Settings/reasons";
import DeliveryList from "./Seating/Deliveries/deliveryList";
import ATPView from "./Seating/Orders/ATPView";
import ManualDocBuilder from "./Seating/Settings/manualDocumentBuilder";
import AdminMassRoute from "./Layer/Admin/MassRoute/AdminMassRoute";
import Vendor from "./Seating/Settings/vendor";
import ProductMatrixEntry from "./Seating/Settings/productMatrixEntry";
import Reports from "./Seating/Reports/reports";
import BonusReport from "./Seating/Reports/bonusReport";
import SalesPipelineGraphView from "./Seating/Reports/salesPipelineGraphView";
import Tasks from "./Seating/Tasks/Tasks";
import PresidentsClubView from "./Seating/PresidentsClub/presidentsClubView";
import ShippingDetailsReport from "./Seating/PurchaseQueue/ShippingDetailsReport";
import ServicePartList from "./Seating/PurchaseQueue/ServicePartList";
import MonthGlanceView from "./Components/Pipeline/MonthGlance";
import ChartContextProvider from "./Context/ChartContext/ChartContext";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";


class Routes extends React.Component {
    render() {
        return (
            <Switch>
                <Route exact path="/" component={Login} />
                <Route exact path="/logout" component={Logout} />
                <Route exact path="/authorize" component={Authorize} />
                <Route exact path="/load" component={Load} />
                <Route exact path="/dashboard" component={QueueDashboard} />
                <Route
                    exact
                    path="/patientInformation/:id"
                    component={PatientInformationView}
                />
                <Route
                    exact
                    path="/patientInformation/:id/:orderId"
                    component={PatientInformationView}
                />
                <Route exact path="/userList" component={UserList} />
                <Route exact path="/user/:id" component={UserEdit} />

                {/* Admin */}
                <Route exact path="/admin/queueTypes" component={AdminTermListQueueType} />
                <Route exact path="/admin/queueType/:id" component={AdminTermCreateEditQueueType} />
                <Route exact path="/admin/queueType" component={AdminTermCreateEditQueueType} />

                <Route exact path="/admin/departments" component={AdminDepartmentList} />
                <Route exact path="/admin/department/:id" component={AdminDepartmentCreateEdit} />
                <Route exact path="/admin/department" component={AdminDepartmentCreateEdit} />

                <Route exact path="/admin/teams" component={AdminTeamList} />
                <Route exact path="/admin/team" component={AdminTeamCreateEdit} />
                <Route exact path="/admin/team/:id" component={AdminTeamCreateEdit} />
                <Route exact path="/admin/roles" component={AdminRoleList} />
                <Route exact path="/admin/role" component={AdminRoleCreateEdit} />
                <Route exact path="/admin/role/:id" component={AdminRoleCreateEdit} />
                <Route exact path="/admin/permissions" component={AdminPermissionList} />
                <Route exact path="/admin/permission" component={AdminPermissionCreateEdit} />
                <Route exact path="/admin/permission/:id" component={AdminPermissionCreateEdit} />

                <Route exact path="/admin/orderActivityTypes" component={AdminOrderActivityTypeList} />
                <Route exact path="/admin/orderActivityType" component={AdminOrderActivityTypeCreateEdit} />
                <Route exact path="/admin/orderActivityType/:id" component={AdminOrderActivityTypeCreateEdit} />

                <Route exact path="/admin/queues" component={AdminQueueList} />
                <Route exact path="/admin/queue" component={AdminQueueCreateEdit} />
                <Route exact path="/admin/queue/:id" component={AdminQueueCreateEdit} />

                <Route exact path="/admin/queueRoutes" component={AdminQueueRouteList} />
                <Route exact path="/admin/queueRoute" component={AdminQueueRouteCreateEdit} />
                <Route exact path="/admin/queueRoute/:id" component={AdminQueueRouteCreateEdit} />

                <Route exact path="/admin/dashboards" component={AdminDashboardList} />
                <Route exact path="/admin/dashboard" component={AdminDashboardCreateEdit} />
                <Route exact path="/admin/dashboard/:id" component={AdminDashboardCreateEdit} />

                <Route exact path="/admin/widgets" component={AdminWidgetList} />
                <Route exact path="/admin/widget" component={AdminWidgetCreateEdit} />
                <Route exact path="/admin/widget/:id" component={AdminWidgetCreateEdit} />

                <Route exact path="/admin/baseUnits" component={AdminBaseUnitList} />
                <Route exact path="/admin/baseUnit" component={AdminBaseUnitCreateEdit} />
                <Route exact path="/admin/baseUnit/:id" component={AdminBaseUnitCreateEdit} />

                <Route exact path="/admin/baseUnitTypes" component={AdminBaseUnitTypeList} />
                <Route exact path="/admin/baseUnitType" component={AdminBaseUnitTypeCreateEdit} />
                <Route exact path="/admin/baseUnitType/:id" component={AdminBaseUnitTypeCreateEdit} />

                <Route exact path="/admin/insuranceSubTypeGroups" component={AdminTermListInsuranceSubTypeGroup} />
                <Route exact path="/admin/insuranceSubTypeGroup/:id" component={AdminTermCreateEditInsuranceSubTypeGroup} />
                <Route exact path="/admin/insuranceSubTypeGroup" component={AdminTermCreateEditInsuranceSubTypeGroup} />

                <Route exact path="/admin/regionTypes" component={AdminTermListRegionType} />
                <Route exact path="/admin/regionType/:id" component={AdminTermCreateEditRegionType} />
                <Route exact path="/admin/regionType" component={AdminTermCreateEditRegionType} />

                <Route exact path="/admin/btProducts" component={AdminBtProductList} />
                <Route exact path="/admin/btProduct" component={AdminBtProductCreateEdit} />
                <Route exact path="/admin/btProduct/:id" component={AdminBtProductCreateEdit} />

                <Route exact path="/admin/locations" component={AdminLocationList} />
                <Route exact path="/admin/location" component={AdminLocationCreateEdit} />
                <Route exact path="/admin/location/:id" component={AdminLocationCreateEdit} />

                <Route exact path="/admin/regions" component={AdminRegionList} />
                <Route exact path="/admin/region" component={AdminRegionCreateEdit} />
                <Route exact path="/admin/region/:id" component={AdminRegionCreateEdit} />

                <Route exact path="/admin/marketingCampaigns" component={AdminMarketingCampaignList} />
                <Route exact path="/admin/marketingCampaign" component={AdminMarketingCampaignCreateEdit} />
                <Route exact path="/admin/marketingCampaign/:id" component={AdminMarketingCampaignCreateEdit} />

                <Route exact path="/admin/marketingCampaignCategories" component={AdminMarketingCampaignCategoryList} />
                <Route exact path="/admin/marketingCampaignCategory" component={AdminMarketingCampaignCategoryCreateEdit} />
                <Route exact path="/admin/marketingCampaignCategory/:id" component={AdminMarketingCampaignCategoryCreateEdit} />

                <Route exact path="/admin/marketingPreferredContactMethods" component={AdminTermListMarketingPreferredContactMethod} />
                <Route exact path="/admin/marketingPreferredContactMethod" component={AdminTermCreateEditMarketingPreferredContactMethod} />
                <Route exact path="/admin/marketingPreferredContactMethod/:id" component={AdminTermCreateEditMarketingPreferredContactMethod} />

                <Route exact path="/admin/commissionTiers" component={AdminTermListCommissionTier} />
                <Route exact path="/admin/commissionTier" component={AdminTermCreateEditCommissionTier} />
                <Route exact path="/admin/commissionTier/:id" component={AdminTermCreateEditCommissionTier} />

                <Route exact path="/admin/placeOfServices" component={AdminTermListPlaceOfService} />
                <Route exact path="/admin/placeOfService" component={AdminTermCreateEditPlaceOfService} />
                <Route exact path="/admin/placeOfService/:id" component={AdminTermCreateEditPlaceOfService} />

                <Route exact path="/admin/evaluationTypes" component={AdminTermListEvaluationType} />
                <Route exact path="/admin/evaluationType" component={AdminTermCreateEditEvaluationType} />
                <Route exact path="/admin/evaluationType/:id" component={AdminTermCreateEditEvaluationType} />

                <Route exact path="/admin/issueCategories" component={AdminIssueCategoryList} />
                <Route exact path="/admin/issueCategory" component={AdminIssueCategoryCreateEdit} />
                <Route exact path="/admin/issueCategory/:id" component={AdminIssueCategoryCreateEdit} />

                <Route exact path="/admin/issueReasons" component={AdminIssueReasonList} />
                <Route exact path="/admin/issueReason" component={AdminIssueReasonCreateEdit} />
                <Route exact path="/admin/issueReason/:id" component={AdminIssueReasonCreateEdit} />

                <Route exact path="/admin/insuranceTypes" component={AdminInsuranceTypeList} />
                <Route exact path="/admin/insuranceType" component={AdminInsuranceTypeCreateEdit} />
                <Route exact path="/admin/insuranceType/:id" component={AdminInsuranceTypeCreateEdit} />

                <Route exact path="/admin/insuranceSubTypes" component={AdminInsuranceSubTypeList} />
                <Route exact path="/admin/insuranceSubType" component={AdminInsuranceSubTypeCreateEdit} />
                <Route exact path="/admin/insuranceSubType/:id" component={AdminInsuranceSubTypeCreateEdit} />

                <Route exact path="/admin/accountTypes" component={AdminAccountTypeList} />
                <Route exact path="/admin/accountType" component={AdminAccountTypeCreateEdit} />
                <Route exact path="/admin/accountType/:id" component={AdminAccountTypeCreateEdit} />

                <Route exact path="/admin/contactTypes" component={AdminContactTypeList} />
                <Route exact path="/admin/contactType" component={AdminContactTypeCreateEdit} />
                <Route exact path="/admin/contactType/:id" component={AdminContactTypeCreateEdit} />

                <Route exact path="/admin/orderStatusReasons" component={AdminOrderStatusReasonList} />
                <Route exact path="/admin/orderStatusReason" component={AdminOrderStatusReasonCreateEdit} />
                <Route exact path="/admin/orderStatusReason/:id" component={AdminOrderStatusReasonCreateEdit} />

                <Route exact path="/admin/orderStatusReasonDetails" component={AdminOrderStatusReasonDetailList} />
                <Route exact path="/admin/orderStatusReasonDetail" component={AdminOrderStatusReasonDetailCreateEdit} />
                <Route exact path="/admin/orderStatusReasonDetail/:id" component={AdminOrderStatusReasonDetailCreateEdit} />

                <Route exact path="/admin/servicePartCatalogCategories" component={AdminTermListServicePartCatalogCategory} />
                <Route exact path="/admin/servicePartCatalogCategory" component={AdminTermCreateEditServicePartCatalogCategory} />
                <Route exact path="/admin/servicePartCatalogCategory/:id" component={AdminTermCreateEditServicePartCatalogCategory} />

                <Route exact path="/admin/brightreeInvoiceStatuses" component={AdminTermListBrightreeInvoiceStatus} />
                <Route exact path="/admin/brightreeInvoiceStatus/:id" component={AdminTermCreateEditBrightreeInvoiceStatus} />
                <Route exact path="/admin/brightreeInvoiceStatus" component={AdminTermCreateEditBrightreeInvoiceStatus} />

                <Route exact path="/admin/invoiceFollowupStatuses" component={AdminTermListInvoiceFollowupStatus} />
                <Route exact path="/admin/invoiceFollowupStatus/:id" component={AdminTermCreateEditInvoiceFollowupStatus} />
                <Route exact path="/admin/invoiceFollowupStatus" component={AdminTermCreateEditInvoiceFollowupStatus} />

                <Route exact path="/admin/distributionTypes" component={AdminTermListDistributionType} />
                <Route exact path="/admin/distributionType/:id" component={AdminTermCreateEditDistributionType} />
                <Route exact path="/admin/distributionType" component={AdminTermCreateEditDistributionType} />

                <Route exact path="/admin/distributionReasons" component={AdminDistributionReasonList} />
                <Route exact path="/admin/distributionReason/:id" component={AdminDistributionReasonCreateEdit} />
                <Route exact path="/admin/distributionReason" component={AdminDistributionReasonCreateEdit} />

                <Route exact path="/admin/distributionReasons" component={AdminDistributionReasonList} />
                <Route exact path="/admin/distributionReason/:id" component={AdminDistributionReasonCreateEdit} />
                <Route exact path="/admin/distributionReason" component={AdminDistributionReasonCreateEdit} />

                <Route exact path="/admin/timeZones" component={AdminTermListTimeZone} />
                <Route exact path="/admin/timeZone/:id" component={AdminTermCreateEditTimeZone} />
                <Route exact path="/admin/timeZone" component={AdminTermCreateEditTimeZone} />

                <Route exact path="/admin/diagnosisCodes" component={AdminDiagnosisCodeList} />
                <Route exact path="/admin/diagnosisCode/:id" component={AdminDiagnosisCodeCreateEdit} />
                <Route exact path="/admin/diagnosisCode" component={AdminDiagnosisCodeCreateEdit} />

                <Route exact path="/admin/hcpcsCodes" component={AdminHcpcsCodeList} />
                <Route exact path="/admin/hcpcsCode/:id" component={AdminHcpcsCodeCreateEdit} />
                <Route exact path="/admin/hcpcsCode" component={AdminHcpcsCodeCreateEdit} />

                <Route exact path="/admin/providers" component={AdminProviderList} />
                <Route exact path="/admin/provider/:id" component={AdminProviderCreateEdit} />
                <Route exact path="/admin/provider" component={AdminProviderCreateEdit} />

                <Route exact path="/admin/userProductionTypes" component={AdminUserProductionTypeList} />
                <Route exact path="/admin/userProductionType/:id" component={AdminUserProductionTypeCreateEdit} />
                <Route exact path="/admin/userProductionType" component={AdminUserProductionTypeCreateEdit} />

                <Route exact path="/admin/userProductionDetailTypes" component={AdminTermListUserProductionDetailType} />
                <Route exact path="/admin/userProductionDetailType/:id" component={AdminTermCreateEditUserProductionDetailType} />
                <Route exact path="/admin/userProductionDetailType" component={AdminTermCreateEditUserProductionDetailType} />

                <Route exact path="/admin/notificationStatuses" component={AdminTermListNotificationStatus} />
                <Route exact path="/admin/notificationStatus/:id" component={AdminTermCreateEditNotificationStatus} />
                <Route exact path="/admin/notificationStatus" component={AdminTermCreateEditNotificationStatus} />

                <Route exact path="/admin/notificationTypes" component={AdminTermListNotificationType} />
                <Route exact path="/admin/notificationType/:id" component={AdminTermCreateEditNotificationType} />
                <Route exact path="/admin/notificationType" component={AdminTermCreateEditNotificationType} />

                <Route exact path="/admin/notificationChannels" component={AdminTermListNotificationChannel} />
                <Route exact path="/admin/notificationChannel/:id" component={AdminTermCreateEditNotificationChannel} />
                <Route exact path="/admin/notificationChannel" component={AdminTermCreateEditNotificationChannel} />

                <Route exact path="/admin/serviceQuotePartStatuses" component={AdminTermListServiceQuotePartStatus} />
                <Route exact path="/admin/serviceQuotePartStatus/:id" component={AdminTermCreateEditServiceQuotePartStatus} />
                <Route exact path="/admin/serviceQuotePartStatus" component={AdminTermCreateEditServiceQuotePartStatus} />

                <Route exact path="/admin/serviceQuotePartSources" component={AdminTermListServiceQuotePartSource} />
                <Route exact path="/admin/serviceQuotePartSource/:id" component={AdminTermCreateEditServiceQuotePartSource} />
                <Route exact path="/admin/serviceQuotePartSource" component={AdminTermCreateEditServiceQuotePartSource} />

                <Route exact path="/admin/serviceQuotePartReasons" component={AdminTermListServiceQuotePartReason} />
                <Route exact path="/admin/serviceQuotePartReason/:id" component={AdminTermCreateEditServiceQuotePartReason} />
                <Route exact path="/admin/serviceQuotePartReason" component={AdminTermCreateEditServiceQuotePartReason} />

                <Route exact path="/admin/distributionReasonTypes" component={AdminTermListDistributionReasonType} />
                <Route exact path="/admin/distributionReasonType/:id" component={AdminTermCreateEditDistributionReasonType} />
                <Route exact path="/admin/distributionReasonType" component={AdminTermCreateEditDistributionReasonType} />

                <Route exact path="/admin/noteTypes" component={AdminTermListNoteType} />
                <Route exact path="/admin/noteType/:id" component={AdminTermCreateEditNoteType} />
                <Route exact path="/admin/noteType" component={AdminTermCreateEditNoteType} />

                <Route exact path="/admin/activityFileTypes" component={AdminTermListActivityFileType} />
                <Route exact path="/admin/activityFileType/:id" component={AdminTermCreateEditActivityFileType} />
                <Route exact path="/admin/activityFileType" component={AdminTermCreateEditActivityFileType} />
                <Route exact path="/admin/terms" component={AdminTerms} />
                <Route exact path="/admin/term/:id" component={AdminTermCreateEditTerms} />
                <Route exact path="/admin/term" component={AdminTermCreateEditTerms} />

                <Route exact path="/admin/businesssSupportRequestResolutions" component={AdminTermListBusinessSupportRequestResolution} />
                <Route exact path="/admin/businesssSupportRequestResolution/:id" component={AdminTermCreateEditBusinessSupportRequestResolution} />
                <Route exact path="/admin/businesssSupportRequestResolution" component={AdminTermCreateEditBusinessSupportRequestResolution} />

                <Route exact path="/admin/modifierCodes" component={AdminModifierCodeList} />
                <Route exact path="/admin/modifierCode/:id" component={AdminModifierCodeCreateEdit} />
                <Route exact path="/admin/modifierCode" component={AdminModifierCodeCreateEdit} />

                <Route exact path="/admin/feeSchedules" component={AdminFeeScheduleList} />
                <Route exact path="/admin/feeSchedule/:id" component={AdminFeeScheduleCreateEdit} />
                <Route exact path="/admin/feeSchedule" component={AdminFeeScheduleCreateEdit} />
                {/*
                <Route exact path="/admin/genderIdentities" component={AdminTermListGenderIdentity} />
                <Route exact path="/admin/genderIdentity/:id" component={AdminTermCreateEditGenderIdentity} />
                <Route exact path="/admin/genderIdentity" component={AdminTermCreateEditGenderIdentity} />

                <Route exact path="/admin/preferredPronouns" component={AdminTermListPreferredPronouns} />
                <Route exact path="/admin/preferredPronoun/:id" component={AdminTermCreateEditPreferredPronouns} />
                <Route exact path="/admin/preferredPronoun" component={AdminTermCreateEditPreferredPronouns} /> */}

                <Route exact path="/admin/brightreeStopHoldTypes" component={AdminTermListBrightreeStopHoldType} />
                <Route exact path="/admin/brightreeStopHoldType/:id" component={AdminTermCreateEditBrightreeStopHoldType} />
                <Route exact path="/admin/brightreeStopHoldType" component={AdminTermCreateEditBrightreeStopHoldType} />

                <Route exact path="/admin/brightreeStopHoldReasons" component={AdminTermListBrightreeStopHoldReason} />
                <Route exact path="/admin/brightreeStopHoldReason/:id" component={AdminTermCreateEditBrightreeStopHoldReason} />
                <Route exact path="/admin/brightreeStopHoldReason" component={AdminTermCreateEditBrightreeStopHoldReason} />

                {/* Queue */}
                <Route exact path="/queue/:id" component={Queue} />
                
                {/* Dashboard */}
                <Route
                    exact
                    path="/dashboard/:dashboardId/:widgetId?"
                    render={(routeProperties) => (
                        <Dashboard
                            key={`dashboard-${routeProperties.match.params.dashboardId}-${routeProperties.match.params.widgetId || ''}`}
                            {...routeProperties}
                        />
                    )}
                />

                {/* Inbound Files */}
                <Route exact path="/inboundFiles" component={InboundFiles} />

                {/* Chart */}
                <Route exact path="/patient/create" component={PatientCreate} />
                <Route exact path="/patient/search" component={PatientSearch} />
                <Route
                    path="/chart/:id"
                    render={(routeProps) => (
                        <ChartContextProvider key={routeProps.match.params.id}>
                            <Switch>
                                <Route exact path="/chart/:id" component={Chart} />
                                <Route exact path="/chart/:id/order/:orderId" component={Chart} />

                                <Route exact path="/chart/:id/new" component={Chart} />
                                <Route exact path="/chart/:id/resupply" component={Chart} />
                                <Route exact path="/chart/:id/order/:orderId/service" component={Chart} />
                                <Route exact path="/chart/:id/order/:orderId/accessoryAfterSale" component={Chart} />
                                <Route exact path="/chart/:id/order/:orderId/pickup" component={Chart} />
                                <Route exact path="/chart/:id/order/:orderId/billingIssue" component={Chart} />
                                <Route exact path="/chart/:id/order/:orderId/atpAssessment" component={Chart} />
                                <Route exact path="/chart/:id/order/:orderId/atpAssessmentEdit" component={Chart} />
                                <Route exact path="/chart/:id/order/:orderId/atpAssessmentSign" component={Chart} />
                                <Route exact path="/chart/:id/order/:orderId/homeAssessment" component={Chart} />
                                <Route exact path="/chart/:id/order/:orderId/homeAssessmentEdit" component={Chart} />
                                <Route exact path="/chart/:id/insuranceDiscovery" component={Chart} />
                                <Route exact path="/chart/:id/order/:orderId/insuranceDiscovery" component={Chart} />
                            </Switch>
                        </ChartContextProvider>
                    )}
                />
                <Route
                    exact
                    path="/order/:id/deliveryManifest"
                    component={DeliveryManifest}
                />

                <Route
                    exact
                    path="/thirdPartyUserList"
                    component={ThirdPartyUserList}
                />

                <Route exact path="/file/:id/:filename" component={FileViewer} />

                <Route exact path="/inventoryTracking/" component={InventoryTacking} />
                <Route exact path="/addUser/" component={UserAdd} />

                {/* Activity Route */}
                <Route exact path="/sales/activities" component={ActivityList} />
                <Route exact path="/activity/:id" component={ActivityEdit} />
                
                {/*Settings Route */}
                <Route exact path="/products" component={ProductTypes} />
                <Route exact path="/products/:id" component={EditProductSubType} />
                <Route exact path="/productType/new" component={AddProductSubType} />
                <Route exact path={"/stateSalesTax"} component={StateSalesTax} />
                <Route exact path="/creditCardTypes" component={CreditCardTypes} />
                <Route exact path="/expenseTypes" component={ExpenseTypes} />
                <Route
                    exact
                    path="/deliveryAcknowledgements"
                    component={DeliveryAcknowledgements}
                />
                <Route
                    exact
                    path="/deliveryAcknowledgements/new"
                    component={AddDeliveryAcknowledgement}
                />
                <Route exact path="/reasons" component={Reasons} />
                <Route exact path="/deliveries" component={DeliveryList} />
                <Route exact path="/atp" component={ATPView} />
                <Route
                    exact
                    path="/manualDocumentBuilder"
                    component={ManualDocBuilder}
                />
                <Route exact path="/admin/massRoute" component={AdminMassRoute} />
                <Route exact path="/vendors" component={Vendor} />
                <Route
                    exact
                    path="/productMatrixEntry"
                    component={ProductMatrixEntry}
                />

                {/* Sales Routes */}
                <Route exact path="/sales/pcrLinks" component={PcrLinks} />

                {/*Report Routes*/}
                <Route exact path="/reports/home" component={Reports} />
                <Route exact path="/reports/salesPipeline" component={SalesPipelineGraphView} />
                <Route exact path="/reports/monthGlance" component={MonthGlanceView} />
                <Route exact path="/reports/metric" component={ReportMetric} />
                <Route exact path="/reports/ARDashboard" component={ARDashboard} />
                <Route exact path="/reports/orderTimelineAudit" component={OrderTimelineAudit} />
                <Route exact path={"/reports/userProductionDetail/invoiceProduction"} component={UserProductionDetailBrightreeInvoice}/>
                <Route exact path="/dailyOrderCounts" component={DailyOrderCounts} />
                <Route exact path={"/sales/scorecard"} component={SalesScorecard} />
                <Route exact path={"/sales/inServiceSummary"} component={InServiceSummary} />

                {/* Marketing Accounts */}

                <Route exact path="/marketing/accounts" component={AccountList} />

                {/* New Account Routes */}
                <Route exact path={'/sales/patients'} render={() => <Redirect to='/queue/92' />} />
                <Route exact path={"/sales/accounts"} component={MyAccounts} />
                <Route exact path="/account/:id/detail" component={AccountDetail} />
                <Route exact path={"/account/create"} component={AccountCreateEdit} />
                <Route exact path={"/account/:id"} component={AccountCreateEdit} />

                {/* Operations Routes */}
                <Route exact path="/order" component={OrderList} />
                <Route exact path="/operations/patientCollections" component={PatientCollections} />
                <Route exact path="/collections" component={CollectionsView} />
                <Route exact path="/recurringOrders/" component={RecurringOrders} />

                {/* Task Route */}
                <Route exact path="/tasks" component={Tasks} />

                {/*Purchasing Routes*/}
                <Route exact path="/purchaseQueues" component={PurchaseQueueView} />
                <Route exact path="/inventoryRequest" component={InventoryRequest} />
                <Route exact path="/shippingDetails" component={ShippingDetailsReport} />

                <Route exact path="/contact/:id" component={ContactEdit} />

                {/*President's Club Routes*/}
                <Route exact path="/presidentsClub" component={PresidentsClubView} />

                {/*Bonus Points Routes*/}
                <Route exact path="/sales/bonus" component={BonusReport} />

                <Route exact path="/serviceParts" component={ServicePartList} />

                <Route
                    render={function () {
                        return <h1>Not Found</h1>;
                    }}
                />
            </Switch>
        );
    }
}

export default Routes;
